<div
    class="py-3"
    [formGroup]="form()">

    <div class="mb-4">
        <text-input
            [formGroup]="form()"
            id="code"
            required="true"
            focus="true"
            [maxLength]="16"
            label="Department Code" />

        <name-validation-errors
            [formGroup]="form()"
            id="code"
            label="Department Code" />
    </div>



    <div class="mb-4">
        <text-input
            [formGroup]="form()"
            id="name"
            required="true"
            focus="true"
            [maxLength]="128"
            label="Department Name" />

        <name-validation-errors
            [formGroup]="form()"
            id="name"
            label="Department Name" />
    </div>

        
    <div class="mb-4">
        <program-selection-list
            [programs]="programs()"
            [formGroup]="form()"
            required="true"
            id="program" />
    </div>

        
    <div class="mb-4">
        <project-selection-list
            [projects]="projects()"
            [formGroup]="form()"
            required="true"
            id="project" />
    </div>
</div>
